import { inject, Injectable } from "@angular/core";
import { ConfigService } from "../config.service";
import { ContactCardFragment } from "../api";

@Injectable({
    providedIn: 'root'
})
export class UrlService {

    config = inject(ConfigService)

    getYoutubeVideoId(url: string): string {

        if (url.toLowerCase().includes('youtube.com/shorts')) {
            return url.split('/').pop()?.split('?')[0] ?? ""
        } else if (url.toLowerCase().includes('youtube.com')) {
            return url.split('&')[0].split('?v=')[1]
        } else if (url.toLowerCase().includes('youtu.be')) {
            return url.split('/').pop() ?? ""
        }

        return ""

    }

    getContactCardUrl(custId: number | null, options: {tripId?: number | null | undefined, selectedTab?: ContactCardFragment, angularRoute?: boolean}): string {
       
       
    // Handle null values
    if (custId === null || custId === undefined) {
        return '';
      }
      
      let url = `/contact-card/${custId.toString()}`

      if (!options?.angularRoute) {
        url = `${this.config.baseUrl}${url}`
      }
  
      if (options?.tripId !== null && options?.tripId !== undefined) {
        url += `?trip=${options.tripId.toString()}`
      }
  
      if (options?.selectedTab) {
        url += "#" + options.selectedTab
      }
  
      return url
       
    }

}